export const featureFlags = {
  enableOpportunitiesConfiguration: true,
};
